export * from "./components/user-profile/user-profile.component";
export * from "./resolvers/user-profile.resolver";
export * from "./shared-user-profile.module";
export * from "./user-profile.tokens";
